/* eslint-disable @typescript-eslint/no-unused-vars */
import { makeAutoObservable, toJS } from 'mobx';
import { formatEmptyToNull } from '@utils/formatData';
import { LxSiteClick } from '@utils/siteLx';
import { LX_RESUME_EDIT_MODULE_ADD, LX_RESUME_EDIT_MODULE_DELETE } from '@common/const';

import {
  ISocialBaseInfo,
  ISocialEduExperience,
  ISocialWorkExperience,
  ISocialProjectExperience,
  ISocialHonor,
  ISocialLanguage,
  ISocialCertificate,
  ISocialPatent,
  ISocialExam,
  ISocialAccount,
  ISocialResumeAttachmentList,
  ISocialWorksAttachmentList,
  resumeBaseInfoDefault,
  resumeEduExpListDefault,
  resumeWorkExpListDefault,
  resumeProjectExpListDefault,
  resumeHonorListDefault,
  resumeLanguageListDefault,
  resumeCertificateListDefault,
  resumePatentListDefault,
  resumeExamListDefault,
  resumeSocialAccountListDefault,
  resumeAttachmentListDefault,
} from '../types/socialType ';

export default class SocialResumeDetail {
  constructor() {
    makeAutoObservable(this);
  }

  resumeUnionId: string;

  updateTime: number;

  resumeBaseInfo: ISocialBaseInfo;

  resumeEduExpList: ISocialEduExperience[];

  resumeWorkExpList: ISocialWorkExperience[];

  resumeProjectExpList: ISocialProjectExperience[];

  resumeHonorList: ISocialHonor[];

  resumeLanguageList: ISocialLanguage[];

  resumeCertificateList: ISocialCertificate[];

  resumePatentList: ISocialPatent[];

  resumeExamList: ISocialExam[];

  resumeSocialAccountList: ISocialAccount[];

  description: string;

  resumeWorksAttachmentList: ISocialWorksAttachmentList[]; // 作品集

  resumeAttachmentList: ISocialResumeAttachmentList[];

  formatResumeKey: string;

  key = [
    'resumeBaseInfo',
    'resumeEduExpList',
    'resumeWorkExpList',
    'resumeProjectExpList',
    'resumeHonorList',
    'resumeLanguageList',
    'resumeCertificateList',
    'resumePatentList',
    'resumeExamList',
    'resumeSocialAccountList',
    'description',
    'resumeWorksAttachmentList',
    'resumeAttachmentList',
  ];

  setStoreData = (resumeInfo) => {
    this.resumeUnionId = resumeInfo?.resumeUnionId;
    this.formatResumeKey = resumeInfo?.formatResumeKey;
    this.updateTime = resumeInfo?.resumeVo?.updateTime;
    if (resumeInfo?.resumeVo) {
      Object.keys(resumeInfo.resumeVo).forEach((key) => {
        if (resumeInfo.resumeVo[key] instanceof Array) {
          resumeInfo.resumeVo[key].forEach((item) => {
            item.renderId = Math.random();
          });
        }
        this[key] = resumeInfo.resumeVo[key];
      });
    } else {
      this.key.map((key) => {
        this[key] = null;
        return false;
      });
    }
  };

  // 修改基础信息
  setResumeBaseInfo = (fieldType, fieldValue) => {
    if (!this.resumeBaseInfo) this.resumeBaseInfo = resumeBaseInfoDefault;
    this.resumeBaseInfo[fieldType] = fieldValue;
  };

  // 修改简历字段
  setResumeAttachmentList = (fieldType, fieldValue) => {
    if (!this.resumeAttachmentList[0])
      this.resumeAttachmentList[0] = { ...resumeAttachmentListDefault, renderId: Math.random() };
    this.resumeAttachmentList[0][fieldType] = fieldValue;
  };

  // 修改证书
  setResumeCertificateList = (index, fieldType, fieldValue) => {
    if (!this.resumeCertificateList[index])
      this.resumeCertificateList[index] = { ...resumeCertificateListDefault, renderId: Math.random() };
    this.resumeCertificateList[index][fieldType] = fieldValue;
  };

  // 修改教育经历
  setResumeEduExpList = (index, fieldType, fieldValue) => {
    if (!this.resumeEduExpList[index])
      this.resumeEduExpList[index] = { ...resumeEduExpListDefault, renderId: Math.random() };
    this.resumeEduExpList[index][fieldType] = fieldValue;
  };

  // 修改荣誉
  setResumeHonorList = (index, fieldType, fieldValue) => {
    if (!this.resumeHonorList[index])
      this.resumeHonorList[index] = { ...resumeHonorListDefault, renderId: Math.random() };
    this.resumeHonorList[index][fieldType] = fieldValue;
  };

  // 修改考试信息
  setResumeExamList = (index, fieldType, fieldValue) => {
    if (!this.resumeExamList[index]) this.resumeExamList[index] = { ...resumeExamListDefault, renderId: Math.random() };
    this.resumeExamList[index][fieldType] = fieldValue;
  };

  // 修改语言水平
  setResumeLanguageList = (index, fieldType, fieldValue) => {
    if (!this.resumeLanguageList[index])
      this.resumeLanguageList[index] = { ...resumeLanguageListDefault, renderId: Math.random() };
    this.resumeLanguageList[index][fieldType] = fieldValue;
  };

  // 修改专利
  setResumePatentList = (index, fieldType, fieldValue) => {
    if (!this.resumePatentList[index])
      this.resumePatentList[index] = { ...resumePatentListDefault, renderId: Math.random() };
    this.resumePatentList[index][fieldType] = fieldValue;
  };

  // 修改项目经历
  setResumeProjectExpList = (index, fieldType, fieldValue) => {
    if (!this.resumeProjectExpList[index])
      this.resumeProjectExpList[index] = { ...resumeProjectExpListDefault, renderId: Math.random() };
    this.resumeProjectExpList[index][fieldType] = fieldValue;
  };

  // 修改自我描述
  setDescription = (fieldType, fieldValue) => {
    this[fieldType] = fieldValue;
  };

  // 修改社交账号
  setResumeSocialAccountList = (index, fieldType, fieldValue) => {
    if (!this.resumeSocialAccountList[index])
      this.resumeSocialAccountList[index] = { ...resumeSocialAccountListDefault, renderId: Math.random() };
    this.resumeSocialAccountList[index][fieldType] = fieldValue;
  };

  // 修改工作经历
  setResumeWorkExpList = (index, fieldType, fieldValue) => {
    if (!this.resumeWorkExpList[index])
      this.resumeWorkExpList[index] = { ...resumeWorkExpListDefault, renderId: Math.random() };
    this.resumeWorkExpList[index][fieldType] = fieldValue;
  };

  // 增加模块
  addResumeList = (type: string, data: any) => {
    LxSiteClick({ bid: LX_RESUME_EDIT_MODULE_ADD[type], valLab: { resumeType: 'social' } });
    if (type === 'resumeEduExpList') {
      if (!this.resumeEduExpList) this.resumeEduExpList = [];
      this.resumeEduExpList.push({ ...resumeEduExpListDefault, renderId: Math.random() });
    }
    if (type === 'resumeWorkExpList') {
      if (!this.resumeWorkExpList) this.resumeWorkExpList = [];
      this[type].push({ ...resumeWorkExpListDefault, renderId: Math.random() });
    }
    if (type === 'resumeProjectExpList') {
      if (!this.resumeProjectExpList) this.resumeProjectExpList = [];
      this[type].push({ ...resumeProjectExpListDefault, renderId: Math.random() });
    }
    if (type === 'resumeHonorList') {
      if (!this.resumeHonorList) this.resumeHonorList = [];
      this[type].push({ ...resumeHonorListDefault, renderId: Math.random() });
    }
    if (type === 'resumeLanguageList') {
      if (!this.resumeLanguageList) this.resumeLanguageList = [];
      this[type].push({ ...resumeLanguageListDefault, renderId: Math.random() });
    }
    if (type === 'resumeCertificateList') {
      if (!this.resumeCertificateList) this.resumeCertificateList = [];
      this[type].push({ ...resumeCertificateListDefault, renderId: Math.random() });
    }
    if (type === 'resumePatentList') {
      if (!this.resumePatentList) this.resumePatentList = [];
      this[type].push({ ...resumePatentListDefault, renderId: Math.random() });
    }
    if (type === 'resumeExamList') {
      if (!this.resumeExamList) this.resumeExamList = [];
      this[type].push({ ...resumeExamListDefault, renderId: Math.random() });
    }
    if (type === 'resumeSocialAccountList') {
      if (!this.resumeSocialAccountList) this.resumeSocialAccountList = [];
      this[type].push({ ...resumeSocialAccountListDefault, renderId: Math.random() });
    }
    if (type === 'resumeWorksAttachmentList') {
      if (!this.resumeWorksAttachmentList) this.resumeWorksAttachmentList = [];
      this[type].push({ ...data, renderId: Math.random() });
    }
    if (type === 'resumeAttachmentList') {
      if (!this.resumeAttachmentList) this.resumeAttachmentList = [];
      this[type].push({ ...data, renderId: Math.random() });
    }
  };

  // 减少模块
  deleteResumeList = (type: string, index: number) => {
    LxSiteClick({ bid: LX_RESUME_EDIT_MODULE_DELETE[type], valLab: { resumeType: 'social' } });
    this[type].splice(index, 1);
  };

  // 获取所有数据
  getAllData = () => {
    const param = {
      resumeUnionId: this.resumeUnionId,
      resumeBaseInfo: this.resumeBaseInfo,
      resumeEduExpList: this.resumeEduExpList,
      resumeWorkExpList: this.resumeWorkExpList,
      resumeProjectExpList: this.resumeProjectExpList,
      resumeHonorList: this.resumeHonorList,
      resumeLanguageList:
        this.resumeLanguageList?.length > 0
          ? this.resumeLanguageList?.map((_item) => {
              const { examinationId, examinationName, score, ...arsg } = _item;
              return { ...arsg };
            })
          : [],
      resumeCertificateList: this.resumeCertificateList,
      resumePatentList: this.resumePatentList,
      resumeExamList: this.resumeExamList,
      resumeSocialAccountList: this.resumeSocialAccountList,
      description: this.description,
      resumeWorksAttachmentList: this.resumeWorksAttachmentList,
      resumeAttachmentList: this.resumeAttachmentList,
    };
    return {
      resumeUnionId: this.resumeUnionId,
      formatResumeKey: this.formatResumeKey,
      updateTime: new Date().getTime(),
      resumeVo: formatEmptyToNull(toJS(param)),
    };
  };
}
